import { axios } from '~/axios'
import {
  login as cognitoLogin,
  logout as cognitoLogout,
  samlCodeExchange as cognitoSamlCodeExchange,
  ssoExchange as cognitoSsoExchange,
  ssoLoginUrl as cognitoSsoLoginUrl,
} from '~/features/Auth/repositories/auth-repository'
import store from '~/redux'

export async function changePassword(userPasswords: Record<string, unknown>) {
  return await axios.post('/graphql', {
    query:
      'mutation changePassword($oldPassword: String, $newPassword : String, $repeatNewPassword : String) {changePassword(oldPassword: $oldPassword, newPassword: $newPassword, repeatNewPassword : $repeatNewPassword){successful}}',
    variables: {
      oldPassword: userPasswords.currentPassword,
      newPassword: userPasswords.newPassword,
      repeatNewPassword: userPasswords.repeatNewPassword,
    },
  })
}

export async function getToken(formData: FormData) {
  return await cognitoLogin({
    userName: formData.get('username') as string,
    password: formData.get('password') as string,
    clientType: 'WEB',
  })
}

export async function logout() {
  const { user } = store.getState()
  return await cognitoLogout({ refreshToken: user?.refreshToken ?? '' })
}

export async function logoutWithToken(refreshToken: string) {
  return await cognitoLogout({ refreshToken })
}

export async function ssoLogin(
  code: string,
  redirectUri: string,
  clientType?: string,
) {
  return await cognitoSsoExchange({ code, redirectUri, clientType })
}

export async function getSsoLoginUrl(redirectUri: string, state?: string) {
  return await cognitoSsoLoginUrl({ redirectUri, state })
}

export async function exchangeSamlCode(code: string) {
  return await cognitoSamlCodeExchange({ code })
}
